<app-accordion *transloco="let t">
  <details appExpansion>
    <summary>{{ t('Safety') }}</summary>
    <div class="description-wrapper">
      <div class="description-item">
        <div class="description-title">{{ t('Manufacturer') }}:</div>
        <div class="description-data">
          <address>
            YES Biżuteria S.A. <br />
            ul. Świerzawska 1, 60-321 Poznań
          </address>
        </div>
      </div>
      <div class="description-item">
        <div class="description-title">{{ t('Contact for GPSR') }}:</div>
        <div class="description-data">
          <a href="mailto:gpsr@yes.pl">gpsr&#64;yes.pl</a>
        </div>
      </div>
      <div class="description-item">
        <div class="description-title">{{ t('Product type') }}:</div>
        <div class="description-data">{{ productType }}</div>
      </div>
    </div>
    <div class="safety-wrapper">
      <div class="safety-title">{{ t('Safety') }}:</div>
      <div class="safety-data">{{ t('Safety info') }}</div>
    </div>
    <a href="https://qr.yes.pl/{{ productType }}" target="_blank">
      {{ t('Product passport') }}
    </a>
  </details>
</app-accordion>
